// extracted by mini-css-extract-plugin
module.exports = {"discountsGrid":"Discounts_discountsGrid__2uzNr","emptyContent":"Discounts_emptyContent__1O_fG","arrowUp":"Discounts_arrowUp__1p8FB"};